<div class="content-wrapper">

  <section class="content-header">
    <h1>
      Assinador de documentos
      <small>Assine seus documentos digitalmente</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="/home">
          <i class="fa fa-home"></i> Home</a>
      </li>
      <li class="active">Assinador documentos</li>
    </ol>
  </section>

  <br>

  <div class="col-sm-12">
    <iframe *ngIf="urlDocumentSignatureApplication" [src]="urlDocumentSignatureApplication | safe"
            style="width: 100%; height: 100vh; border: none"></iframe>
  </div>

</div>